import { MLQuoteNameUtil } from 'ml-portals-util-js';

const LOB = {
    HOMEOWNERS: 'HOPLine',
    PERSONAL_AUTO: 'PersonalAutoLine',
    UMBRELLA: 'PersonalUmbrellaLine_PUE'
};
const DISPLAY_STATE = [LOB.PERSONAL_AUTO, LOB.UMBRELLA];

export default {
    LOB,
    getLOBSortIndex: (policy) => {
        switch (policy.policyLines[0].lineOfBusinessCode) {
            case LOB.HOMEOWNERS:
                return 2;
            case LOB.PERSONAL_AUTO:
                return 1;
            case LOB.UMBRELLA:
                return 3;
            default:
                return 99;
        }
    },
    getLOBPolicyName: (policy) => {
        switch (policy.policyLines[0].lineOfBusinessCode) {
            case LOB.HOMEOWNERS:
                return MLQuoteNameUtil.getCoveragePartTypeName(
                    policy.product ? policy.product.coveragePartType_ML : policy.lobs_ML.homeowners.coveragePartType_ML
                );
            case LOB.PERSONAL_AUTO:
                return 'Auto';
            case LOB.UMBRELLA:
                return 'Umbrella';
            default:
                return policy.policyLines[0].lineOfBusinessName;
        }
    },
    getPolicyLabelState: (policy) => {
        if (DISPLAY_STATE.indexOf(policy.policyLines[0].lineOfBusinessCode) !== -1) {
            return `(${policy.address_ML.state})`;
        }
    }
};